import ApiResponse from "@core/types/apiResponse";
import { ApiMessageResponse } from "@core/types/apiMessageResponse";
import { resetPassword } from "@features/auth/api/authApi";
import { ResetPasswordRequest } from "../types/resetPassword";

export const resetPasswordAsync = async (request: ResetPasswordRequest): Promise<ApiResponse<ApiMessageResponse>> => {
  return resetPassword(request);
};
